import React, { FC, ReactNode } from 'react';

import { Box, StackProps, Stack, BoxProps, Text } from '@chakra-ui/react';
import { customTheme } from 'theme';

import { CustomTooltip } from 'components/DataDisplay';
import { CustomSpinner } from 'components/DataDisplay/Spinner/CustomSpinner';

export interface DetailsIdentifierProps extends StackProps {
  label: string | ReactNode;
  value?: any | ReactNode;
  tooltip?: any | ReactNode;
  styles?: { label?: BoxProps; value?: BoxProps };
  isLoading?: boolean;
  isInline?: boolean;
  showColon?: boolean;
  showValueOverflow?: boolean;
  showTooltip?: boolean;

  /*labelIcon?: {
    type: IconType;
    color: string;
    iconFilled?: boolean;
    iconSize?: string | number;
  };*/
}

export const DetailsIdentifier: FC<DetailsIdentifierProps> = props => {
  const {
    label,
    value,
    styles,
    isLoading = false,
    isInline = true,
    showColon = false,
    showValueOverflow = true,
    showTooltip = false,
    tooltip,
    ...rest
  } = props;

  const valueOverflowStyles = {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  };

  return (
    <Stack
      spacing={isInline ? 2.5 : 0}
      direction={isInline ? 'row' : 'column'}
      overflow="hidden"
      {...rest}
    >
      <Text
        color={customTheme.colors.grey}
        whiteSpace="nowrap"
        spacing={0}
        {...styles?.label}
      >
        {label}
        {showColon && ':'}
      </Text>
      {isLoading ? (
        <Box w={4}>
          <CustomSpinner />
        </Box>
      ) : (
        <Box
          flex={1}
          color={
            value === 'None' || !value
              ? customTheme.colors.gray['200']
              : 'black'
          }
          {...(!showValueOverflow ? valueOverflowStyles : {})}
          {...styles?.value}
        >
          {(showTooltip || !!tooltip) && !!value ? (
            <CustomTooltip label={tooltip ?? value}>{value}</CustomTooltip>
          ) : !!value ? (
            value
          ) : (
            '-'
          )}
        </Box>
      )}
    </Stack>
  );
};
